import { ProfileCompletion } from "@container/profile-completion";
import AuthLayout from "@container/layout/auth";

export default function ProfileCompletionPage() {
    return (
        <AuthLayout>
            <ProfileCompletion />
        </AuthLayout>
    );
}
